import { useSearchspringContext } from '../fetchers/provider'

export function ResultCount({ className }) {
  const { results } = useSearchspringContext()
  return <p className={className}>{results?.pagination?.totalResults} results</p>
}
